import React from "react";
import { IconLayers } from "../ui/icons";
import { useApiData } from "../../hooks/useApiData";
import { unwrapArray } from "../../utils/api";
import Card from "../ui/Card";
import RankedBars from "../ui/RankedBars";
import { ListSkeleton } from "../ui/Skeleton";
import { EmptyState, ErrorState } from "../ui/StateBlock";

/** Share by item group (ranked list, from the largest value). */
export default function GroupShareChart({ startDate, endDate, warehouse }) {
  const hasRange = Boolean(startDate && endDate);

  const { data: raw, loading, error } = useApiData(
    hasRange ? `/group_share.php?od=${startDate}&do=${endDate}${warehouse ? `&warehouse=${warehouse}` : ""}` : null
  );
  const data = [...unwrapArray(raw)].sort((a, b) => b.vrednost - a.vrednost);
  const rows = data.map((d) => ({ label: d.grupa, value: d.vrednost }));

  return (
    <Card title="Udeo po grupama" icon={IconLayers}>
      {error && data.length === 0 ? (
        <ErrorState />
      ) : data.length === 0 && loading ? (
        <ListSkeleton rows={6} />
      ) : data.length === 0 ? (
        <EmptyState title="Nema podataka za izabrani period" />
      ) : (
        <div className="scroll-thin max-h-[420px] overflow-y-auto pr-1">
          <RankedBars rows={rows} />
        </div>
      )}
    </Card>
  );
}
